var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrmNavIcon = function SvgTrmNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M16.25 11.75h6.875L16.25 4.875zM7.5 3h10l7.5 7.5v15a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 5 25.5v-20C5 4.112 6.112 3 7.5 3m10 22.5v-1.25c0-1.663-3.338-2.5-5-2.5s-5 .837-5 2.5v1.25zm-5-10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 18,
    r: 2.5,
    fill: "#FBD15D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M16.25 11.75V4.875l6.875 6.875z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M17.5 25.5h-10v-1.25a2.5 2.5 0 0 1 2.5-2.5h5a2.5 2.5 0 0 1 2.5 2.5z"
  })));
};
export default SvgTrmNavIcon;